// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"01688eac","458":"e1dd3393","730":"106a44b9","774":"4c8be1e0","854":"7926a289","858":"a44e94f5","916":"6ffea21c"}[chunkId] + ".chunk.js";
};